module.exports = __webpack_public_path__ + "img/9788934973188.e7e305f4.jpg";